//import { Layout } from 'antd';
import { ReactNode } from 'react';
import styled from 'styled-components';
import Div100vh from 'react-div-100vh';
import GameHeader from '~/pages/authentified/GameHeader';
import GameFooter from '~/pages/authentified/GameFooter';
import bg from '@assets/images/background/background.jpg';

//const { Content } = Layout;

type IProps = {
  children: ReactNode;
  withoutHeader?: boolean;
  withoutFooter?: boolean;
  blur?: boolean;
  background?: string;
  backgroundSize?: string;
};

function GameLayout({
  children,
  withoutHeader,
  blur,
  background,
  withoutFooter,
  backgroundSize,
}: IProps) {
  return (
    <Container
      $backgroundSize={backgroundSize}
      $background={background ? background : bg}
    >
      {blur && <Blured></Blured>}
      {!withoutHeader && <GameHeader />}
      <SDivContent>{children}</SDivContent>
      {!withoutFooter && <GameFooter />}
    </Container>
  );
}

export default GameLayout;

const Blured = styled.div`
  display: block;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  pointer-events: none;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.3) 0%,
    rgba(255, 255, 255, 0.03) 50%,
    rgba(255, 255, 255, 0.3) 100%
  );
  backdrop-filter: blur(8px);
  z-index: 1;
`;

const Container = styled(Div100vh)<{
  $background?: string;
  $backgroundColor?: string;
  $backgroundSize?: string;
}>`
  align-items: center;
  background-color: ${({ $backgroundColor }) =>
    $backgroundColor ? `${$backgroundColor}` : '#3A616B'};
  background-image: ${({ $background }) =>
    $background ? `url('${$background}')` : 'none'};
  background-position: center;
  background-size: ${({ $backgroundSize }) =>
    $backgroundSize ? $backgroundSize : 'auto 100%'};

  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
  overflow: hidden;
  position: relative;
  width: 100%;
`;

const SDivContent = styled.div`
  align-items: center;
  display: flex;
  flex-grow: 1;
  width: 100%;
  justify-content: center;
  z-index: 2;
  height: 100%;
`;
